module.exports = __webpack_public_path__ + "img/150.friend.192c2167.svg";